import React from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { Page, Content } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core/styles';
import { UserHealthDashboard } from '../catalog/group/team/tabs/health/UserHealthDashboard';

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 0,
  },
}));

export const UserHealthPage: React.FC = () => {
  const classes = useStyles();
  const { email } = useParams<{ email: string }>();
  const navigate = useNavigate();

  if (!email) {
    return <Navigate to="/" replace />;
  }

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Page themeId="home">
      <Content className={classes.root}>
        <UserHealthDashboard
          weaveEmail={decodeURIComponent(email)}
          onBack={handleBack}
        />
      </Content>
    </Page>
  );
};

export default UserHealthPage;
